// External deps

import PropTypes from 'prop-types';

// Internal deps
import { classNames } from '../../utils/formatUtils';
import './RequestsIcon.scss';

const shapeEnum = {
  circle: 0,
  square: 1,
  diamond: 2,
  triangle: 3
};

const RequestsIcon = ({ shape, color, letter }) => {
  const selectShape = () => {
    if (shape === shapeEnum.circle) {
      return 'circle';
    }
    if (shape === shapeEnum.square) {
      return 'square';
    }
    if (shape === shapeEnum.diamond) {
      return 'diamond';
    }
    if (shape === shapeEnum.triangle) {
      return 'triangle';
    }

    return '';
  };

  return (
    <div className="requests-icon">
      <span
        className={classNames('shape', selectShape())}
        style={{
          backgroundColor: color
        }}
      />
      <span className={classNames('letter', selectShape())}> {letter} </span>
    </div>
  );
};

export default RequestsIcon;

RequestsIcon.propTypes = {
  shape: PropTypes.number,
  color: PropTypes.string,
  letter: PropTypes.string.isRequired
};

RequestsIcon.defaultProps = {
  shape: shapeEnum.circle,
  color: '#37A08C'
};
